import { CandidatStatusOnMission } from '../enums';

export const StrongPasswordRegx: RegExp =
  /^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=\D*\d).{8,}(?=.*[!@#$%^&*/])/;

export const candidatAccepted: CandidatStatusOnMission[] = [
  CandidatStatusOnMission.ACCEPTED,
  CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH,
  CandidatStatusOnMission.MISSION_VALIDATED_WAITING_FOR_PAYMENT,
  CandidatStatusOnMission.VALIDATION_REJECTED_BY_ESTABLISHMENT,
  CandidatStatusOnMission.WAITING_FOR_ESTABLISHMENT_VALIDATION,
  CandidatStatusOnMission.PAYMENT_DONE,
];
